import * as React from 'react';



export default class Emptynote extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg width="294" height="188" viewBox="0 0 294 188" version="1.1" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
        <defs>
        <linearGradient id="note__a" x1="50%" x2="50%" y1="0%" y2="74.191%">
            <stop offset="0%" stopColor="#EAEFF2"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="note__c" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="note__g" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="note__i" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="note__l" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="note__n" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="note__p" x1="29.891%" x2="70.109%" y1="-10.556%" y2="100%">
            <stop offset="0%" stopColor="#F07517" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <path id="note__b" d="M1.805.352c-.972 0-1.76.795-1.76 1.776v122.167c0 .98.788 1.776 1.76 1.776h94.606c.972 0 1.76-.796 1.76-1.776V.352H1.805z"/>
        <path id="note__e" d="M0.131 0.129L109.554 0.129 109.554 22.164 0.131 22.164z"/>
        <path id="note__h" d="M24.627 13.348C22.377 31.343.277 35.73.277 35.73c48.757 0 49.51-35.514 49.51-35.514l-25.16 13.13z"/>
        <path id="note__k" d="M15.027 8.263C13.654 19.403.169 22.119.169 22.119c29.75 0 30.21-21.984 30.21-21.984L15.027 8.263z"/>
        <path id="note__o" d="M7.32 0.165L0.276 4.134 22.707 39.818 25.423 38.288z"/>
    </defs>
    <g fill="none" fillRule="evenodd">
        <path fill="url(#note__a)" d="M240 189c0-27.062-43.205-49-96.5-49S47 161.938 47 189" transform="translate(0 -1)"/>
        <path fill="#EBEEF0" d="M196.737 30.188s16.54-.204 16.54 17.009h-16.54v-17.01z" transform="translate(0 -1)"/>
        <g transform="translate(0 -1) translate(98.566 29.836)">
            <mask id="note__d" fill="#fff">
                <use xlinkHref="#note__b"/>
            </mask>
            <path fill="url(#note__c)" d="M1.805.352c-.972 0-1.76.79-1.76 1.766v121.467c0 .976.788 1.767 1.76 1.767h94.606c.972 0 1.76-.791 1.76-1.767V.352H1.805z" mask="url(#note__d)"/>
        </g>
        <g transform="translate(0 -1) translate(85.82 132.984)">
            <mask id="note__f" fill="#fff">
                <use xlinkHref="#note__e"/>
            </mask>
            <path fill="#EBEEF0" d="M99.312 22.164l-95.966-.093C-1.154 14.933-.795 7.7 3.583.465L3.786.13h97.727s-10.448 21.942 8.04 21.942l-10.24.093z" mask="url(#note__f)"/>
        </g>
        <path fill="url(#note__g)" d="M.042 22.39s-.04.628-.042 1.683v.203c.012 5.528 1.063 21.377 12.622 22.605 0 0 28.466-4.395 42.245-31.31 0 0-15.695-5.206-15.695-15.564 0 0-25.61 25.327-39.13 22.382" transform="translate(0 -1) translate(0 83.541)"/>
        <g>
            <path fill="#F3F4F4" d="M.252 36s27.37 4.82 37.85-16.393L.252 36z" transform="translate(0 -1) translate(228.723 80.984)"/>
            <g transform="translate(0 -1) translate(228.723 80.984) translate(15.145)">
                <mask id="note__j" fill="#fff">
                    <use xlinkHref="#note__h"/>
                </mask>
                <path fill="url(#note__i)" d="M24.627 13.348C22.377 31.343.277 35.73.277 35.73c48.757 0 49.51-35.514 49.51-35.514l-25.16 13.13z" mask="url(#note__j)"/>
            </g>
        </g>
        <g>
            <path fill="#F3F4F4" d="M0 22.88s18.06 1.893 24.58-11.24L0 22.88z" transform="translate(0 -1) rotate(30 -11.51 64.242)"/>
            <g transform="translate(0 -1) rotate(30 -11.51 64.242) translate(10.197)">
                <mask id="note__m" fill="#fff">
                    <use xlinkHref="#note__k"/>
                </mask>
                <path fill="url(#note__l)" d="M15.027 8.263C13.654 19.403.169 22.119.169 22.119c29.75 0 30.21-21.984 30.21-21.984L15.027 8.263z" mask="url(#note__m)"/>
            </g>
        </g>
        <path fill="url(#note__n)" d="M14.252 13.348C6.681 12.672.108 30.217.108 30.217S6.4 36.324 13.749 32.98c0 0 .196-9.366 9.836-10.678 9.64-1.31 12.23-12.747 10.631-14.374L21.271.375s.552 13.648-7.019 12.973" transform="translate(0 -1) translate(237.92 15.344)"/>
        <g fill="#FFF">
            <path d="M.347 3.487L65.086 3.487 65.086.312.347.312zM.347 16.93L38.99 16.93 38.99 13.755.347 13.755zM.348 25.891L57.156 25.891 57.156 22.717.348 22.717zM.347 34.853L49.452 34.853 49.452 31.678.347 31.678z" transform="translate(0 -1) translate(111.312 52.852)"/>
        </g>
        <g transform="translate(0 -1) translate(80.723)">
            <mask id="note__q" fill="#fff">
                <use xlinkHref="#note__o"/>
            </mask>
            <path fill="url(#note__p)" d="M4.517 1.744L3.02 2.59c-1.444.813-1.955 2.642-1.142 4.086l.074.124 20.756 33.02 2.716-1.53L8.7 3.07C7.99 1.574 6.2.937 4.703 1.648c-.063.03-.125.062-.186.096z" mask="url(#note__q)"/>
        </g>
        <path fill="#C3CFD8" d="M105.336 37.508L112.162 42.791 110.844 52 103.686 48.021 102.815 39.087z" transform="translate(0 -1)"/>
    </g>
        </svg>
    )
  }
}
